// import React, { useState, useEffect, ChangeEvent } from 'react';
// import {
// 	TextField,
// 	Button,
// 	Select,
// 	MenuItem,
// 	InputLabel,
// 	FormControl,
// 	Typography,
// 	Grid,
// 	Box,
// } from '@mui/material';
// import { SelectChangeEvent } from '@mui/material/Select';
// import { getAllCategory } from '../../../services/api/Category';
// import { PostSubCategories, updateSubCategory } from '../../../services/api/Subcategories';

// interface FormData {
// 	subCategory: string;
// 	description: string;
// 	category: any;
// 	subCategoryImage: File | null;
// 	slug: string;
// }

// interface CreateSubCategoryProps {
// 	subCategory?: FormData | null | any;
// 	onClose: () => void;
// }

// interface Category {
// 	_id: string;
// 	name: string;
// 	subCategory: string;
// 	description: string;
// 	subCategoryImage: string;
// 	status: string;
// 	slug: string;
// 	createdBy: string;
// 	createdAt: string;
// 	updatedAt: string;
// 	__v: number;
// }

// const CreateSubCategory: React.FC<CreateSubCategoryProps> = ({ subCategory, onClose }) => {
// 	const [formData, setFormData] = useState<FormData>({
// 		subCategory: subCategory?.subCategory || '',
// 		description: subCategory?.description || '',
// 		category: subCategory?.category || '',
// 		slug: subCategory?.slug || '',
// 		subCategoryImage: null,
// 	});

// 	const [categories, setCategories] = useState<Category[]>([]);
// 	const [isSlugManuallyEdited, setIsSlugManuallyEdited] = useState(false);
// 	const [imagePreview, setImagePreview] = useState<string | null>(
// 		subCategory?.subCategoryImage ? `${subCategory.subCategoryImage}` : null
// 	);
// 	const [errors, setErrors] = useState({
// 		subCategory: '',
// 		description: '',
// 		category: '',
// 		slug: '',
// 		subCategoryImage: '',
// 	});

// 	useEffect(() => {
// 		const fetchCategories = async () => {
// 			try {
// 				const response = await getAllCategory();
// 				setCategories(response?.data?.categories || []);
// 			} catch (error) {
// 				console.error('Failed to fetch categories:', error);
// 			}
// 		};
// 		fetchCategories();
// 	}, []);

// 	const validateForm = () => {
// 		let valid = true;
// 		const newErrors = {
// 			subCategory: '',
// 			description: '',
// 			category: '',
// 			slug: '',
// 			subCategoryImage: '',
// 		};

// 		if (!formData.subCategory.trim()) {
// 			newErrors.subCategory = 'Sub-category name is required';
// 			valid = false;
// 		}

// 		if (!formData.description.trim()) {
// 			newErrors.description = 'Description is required';
// 			valid = false;
// 		}

// 		if (!formData.category) {
// 			newErrors.category = 'Category is required';
// 			valid = false;
// 		}

// 		if (!formData.slug.trim()) {
// 			newErrors.slug = 'Slug is required';
// 			valid = false;
// 		} else if (!/^[a-z0-9-]+$/.test(formData.slug)) {
// 			newErrors.slug = 'Slug can only contain lowercase letters, numbers, and hyphens';
// 			valid = false;
// 		}

// 		if (!subCategory && !formData.subCategoryImage) {
// 			newErrors.subCategoryImage = 'Image is required';
// 			valid = false;
// 		}

// 		setErrors(newErrors);
// 		return valid;
// 	};

// 	const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
// 		const file = e.target.files?.[0] || null;

// 		if (file) {
// 			// Validate file type
// 			if (!file.type.match('image.*')) {
// 				setErrors((prev) => ({ ...prev, subCategoryImage: 'Please select an image file' }));
// 				return;
// 			}

// 			// Validate file size (e.g., 2MB max)
// 			if (file.size > 2 * 1024 * 1024) {
// 				setErrors((prev) => ({
// 					...prev,
// 					subCategoryImage: 'File size should be less than 2MB',
// 				}));
// 				return;
// 			}

// 			setErrors((prev) => ({ ...prev, subCategoryImage: '' }));
// 			setFormData({
// 				...formData,
// 				subCategoryImage: file,
// 			});
// 			setImagePreview(URL.createObjectURL(file));
// 		}
// 	};

// 	const handleSubCategoryChange = (e: ChangeEvent<HTMLInputElement>) => {
// 		const { name, value } = e.target;
// 		setFormData((prev) => {
// 			const newFormData = {
// 				...prev,
// 				[name]: value,
// 			};

// 			if (name === 'subCategory' && !isSlugManuallyEdited) {
// 				newFormData.slug = value.toLowerCase().replace(/[^a-z0-9-]/g, '-');
// 			}

// 			return newFormData;
// 		});

// 		// Clear error when typing
// 		if (errors.subCategory) {
// 			setErrors((prev) => ({ ...prev, subCategory: '' }));
// 		}
// 	};

// 	const handleSlugChange = (e: ChangeEvent<HTMLInputElement>) => {
// 		const { name, value } = e.target;
// 		const slugValue = value.toLowerCase().replace(/[^a-z0-9-]/g, '-');
// 		setFormData((prev) => ({
// 			...prev,
// 			[name]: slugValue,
// 		}));
// 		setIsSlugManuallyEdited(true);

// 		// Clear error when typing
// 		if (errors.slug) {
// 			setErrors((prev) => ({ ...prev, slug: '' }));
// 		}
// 	};

// 	const handleCategoryChange = (e: SelectChangeEvent<string>) => {
// 		const { name, value } = e.target;
// 		setFormData((prev) => ({
// 			...prev,
// 			[name]: value,
// 		}));

// 		// Clear error when selecting
// 		if (errors.category) {
// 			setErrors((prev) => ({ ...prev, category: '' }));
// 		}
// 	};

// 	const handleSubmit = async (e: React.FormEvent) => {
// 		e.preventDefault();

// 		if (!validateForm()) {
// 			return;
// 		}

// 		const formDataToSend = new FormData();
// 		formDataToSend.append('subCategory', formData.subCategory);
// 		formDataToSend.append('description', formData.description);
// 		formDataToSend.append('category', formData.category);
// 		formDataToSend.append(
// 			'slug',
// 			formData.slug || formData.subCategory.toLowerCase().replace(/[^a-z0-9-]/g, '-')
// 		);

// 		if (formData.subCategoryImage) {
// 			formDataToSend.append('subCategoryImage', formData.subCategoryImage);
// 		}

// 		try {
// 			if (subCategory) {
// 				await updateSubCategory(formDataToSend, subCategory._id);
// 			} else {
// 				await PostSubCategories(formDataToSend);
// 			}
// 			onClose();
// 		} catch (error) {
// 			console.error('Error submitting form:', error);
// 		}
// 	};

// 	return (
// 		<form onSubmit={handleSubmit}>
// 			<Typography variant="h6" gutterBottom>
// 				{subCategory ? 'Edit Sub-Category' : 'Create New Sub-Category'}
// 			</Typography>
// 			<Grid container spacing={2}>
// 				<Grid item xs={12}>
// 					<TextField
// 						label="Sub-Category Name"
// 						variant="outlined"
// 						name="subCategory"
// 						size="small"
// 						fullWidth
// 						value={formData.subCategory}
// 						onChange={handleSubCategoryChange}
// 						error={!!errors.subCategory}
// 						helperText={errors.subCategory}
// 						required
// 					/>
// 				</Grid>
// 				<Grid item xs={12}>
// 					<TextField
// 						label="Slug"
// 						variant="outlined"
// 						name="slug"
// 						size="small"
// 						fullWidth
// 						value={formData.slug}
// 						onChange={handleSlugChange}
// 						helperText={
// 							errors.slug ||
// 							'Only lowercase letters, numbers, and hyphens are allowed'
// 						}
// 						error={!!errors.slug}
// 						required
// 					/>
// 				</Grid>
// 				<Grid item xs={12}>
// 					<TextField
// 						label="Description"
// 						variant="outlined"
// 						size="small"
// 						name="description"
// 						fullWidth
// 						multiline
// 						rows={4}
// 						value={formData.description}
// 						onChange={(e) => {
// 							setFormData((prev) => ({ ...prev, description: e.target.value }));
// 							if (errors.description) {
// 								setErrors((prev) => ({ ...prev, description: '' }));
// 							}
// 						}}
// 						error={!!errors.description}
// 						helperText={errors.description}
// 						required
// 					/>
// 				</Grid>
// 				<Grid item xs={12}>
// 					<FormControl fullWidth size="small" error={!!errors.category}>
// 						<InputLabel>Category *</InputLabel>
// 						<Select
// 							name="category"
// 							value={formData.category}
// 							label="Category *"
// 							onChange={handleCategoryChange}
// 							required
// 						>
// 							<MenuItem value="">Select Category</MenuItem>
// 							{categories.map((category) => (
// 								<MenuItem key={category._id} value={category.name}>
// 									{category.name}
// 								</MenuItem>
// 							))}
// 						</Select>
// 						{errors.category && (
// 							<Box sx={{ color: 'error.main', fontSize: '0.75rem', ml: 2, mt: 0.5 }}>
// 								{errors.category}
// 							</Box>
// 						)}
// 					</FormControl>
// 				</Grid>
// 				<Grid item xs={12}>
// 					<Button variant="contained" component="label">
// 						Upload Image
// 						<input
// 							type="file"
// 							hidden
// 							name="subCategoryImage"
// 							accept="image/*"
// 							onChange={handleFileChange}
// 						/>
// 					</Button>
// 					{errors.subCategoryImage && (
// 						<Box sx={{ color: 'error.main', fontSize: '0.75rem', ml: 2, mt: 0.5 }}>
// 							{errors.subCategoryImage}
// 						</Box>
// 					)}
// 					{(imagePreview || subCategory?.subCategoryImage) && (
// 						<Box sx={{ mt: 2 }}>
// 							<img
// 								src={imagePreview || `${subCategory.subCategoryImage[0]}`}
// 								alt="Preview"
// 								style={{ maxWidth: '100%', maxHeight: 200 }}
// 							/>
// 						</Box>
// 					)}
// 				</Grid>
// 				<Grid item xs={12} sx={{ display: 'flex', gap: 2, justifyContent: 'end' }}>
// 					<Button type="submit" variant="contained" color="primary">
// 						{subCategory ? 'Update Sub-Category' : 'Create Sub-Category'}
// 					</Button>
// 					<Button
// 						variant="outlined"
// 						onClick={onClose}
// 						sx={{ ':hover': { backgroundColor: '#f0f0f0' } }}
// 					>
// 						Cancel
// 					</Button>
// 				</Grid>
// 			</Grid>
// 		</form>
// 	);
// };

// export default CreateSubCategory;
import React, { useState, useEffect, ChangeEvent } from 'react';
import {
	TextField,
	Button,
	Select,
	MenuItem,
	InputLabel,
	FormControl,
	// Typography,
	Grid,
	Box,
	IconButton,
} from '@mui/material';
import { SelectChangeEvent } from '@mui/material/Select';
// import { Delete as DeleteIcon } from '@mui/icons-material';
import CloseIcon from '@mui/icons-material/Close';
import { getAllCategory } from '../../../services/api/Category';
// import { PostSubCategories, updateSubCategory } from '../../../services/api/Subcategories';

interface FormData {
	subCategory: string;
	description: string;
	category: any;
	subCategoryImage: File | null;
	slug: string;
}

interface CreateSubCategoryProps {
	subCategory?: FormData | null | any;
	onClose: () => void;
	onsubmit: any;
}

interface Category {
	_id: string;
	name: string;
	subCategory: string;
	description: string;
	subCategoryImage: string;
	status: string;
	slug: string;
	createdBy: string;
	createdAt: string;
	updatedAt: string;
	__v: number;
}

const CreateSubCategory: React.FC<CreateSubCategoryProps> = ({
	subCategory,
	onClose,
	onsubmit,
}) => {
	const [formData, setFormData] = useState<FormData>({
		subCategory: subCategory?.subCategory || '',
		description: subCategory?.description || '',
		category: subCategory?.category || '',
		slug: subCategory?.slug || '',
		subCategoryImage: null,
	});

	const [categories, setCategories] = useState<Category[]>([]);
	const [isSlugManuallyEdited, setIsSlugManuallyEdited] = useState(false);
	const [imagePreview, setImagePreview] = useState<string | null>(
		subCategory?.subCategoryImage ? `${subCategory.subCategoryImage}` : null
	);
	const [errors, setErrors] = useState({
		subCategory: '',
		description: '',
		category: '',
		slug: '',
		subCategoryImage: '',
	});

	useEffect(() => {
		const fetchCategories = async () => {
			try {
				const response = await getAllCategory();
				setCategories(response?.data?.categories || []);
			} catch (error) {
				console.error('Failed to fetch categories:', error);
			}
		};
		fetchCategories();
	}, []);

	const validateForm = () => {
		let valid = true;
		const newErrors = {
			subCategory: '',
			description: '',
			category: '',
			slug: '',
			subCategoryImage: '',
		};

		if (!formData.subCategory.trim()) {
			newErrors.subCategory = 'Sub-category name is required';
			valid = false;
		}

		if (!formData.description.trim()) {
			newErrors.description = 'Description is required';
			valid = false;
		}

		if (!formData.category) {
			newErrors.category = 'Category is required';
			valid = false;
		}

		if (!formData.slug.trim()) {
			newErrors.slug = 'Slug is required';
			valid = false;
		} else if (!/^[a-z0-9-]+$/.test(formData.slug)) {
			newErrors.slug = 'Slug can only contain lowercase letters, numbers, and hyphens';
			valid = false;
		}

		// if (!subCategory && !formData.subCategoryImage) {
		// 	newErrors.subCategoryImage = 'Image is required';
		// 	valid = false;
		// }

		setErrors(newErrors);
		return valid;
	};

	const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
		const file = e.target.files?.[0] || null;

		if (file) {
			// Validate file type
			if (!file.type.match('image.*')) {
				setErrors((prev) => ({ ...prev, subCategoryImage: 'Please select an image file' }));
				return;
			}

			// Validate file size (e.g., 2MB max)
			if (file.size > 2 * 1024 * 1024) {
				setErrors((prev) => ({
					...prev,
					subCategoryImage: 'File size should be less than 2MB',
				}));
				return;
			}

			setErrors((prev) => ({ ...prev, subCategoryImage: '' }));
			setFormData({
				...formData,
				subCategoryImage: file,
			});
			setImagePreview(URL.createObjectURL(file));
		}
	};

	const handleDeleteImage = () => {
		setFormData({
			...formData,
			subCategoryImage: null,
		});
		setImagePreview(null);
		setErrors((prev) => ({ ...prev, subCategoryImage: '' }));
	};

	const handleSubCategoryChange = (e: ChangeEvent<HTMLInputElement>) => {
		const { name, value } = e.target;
		setFormData((prev) => {
			const newFormData = {
				...prev,
				[name]: value,
			};

			if (name === 'subCategory' && !isSlugManuallyEdited) {
				newFormData.slug = value.toLowerCase().replace(/[^a-z0-9-]/g, '-');
			}

			return newFormData;
		});

		// Clear error when typing
		if (errors.subCategory) {
			setErrors((prev) => ({ ...prev, subCategory: '' }));
		}
	};

	const handleSlugChange = (e: ChangeEvent<HTMLInputElement>) => {
		const { name, value } = e.target;
		const slugValue = value.toLowerCase().replace(/[^a-z0-9-]/g, '-');
		setFormData((prev) => ({
			...prev,
			[name]: slugValue,
		}));
		setIsSlugManuallyEdited(true);

		// Clear error when typing
		if (errors.slug) {
			setErrors((prev) => ({ ...prev, slug: '' }));
		}
	};

	const handleCategoryChange = (e: SelectChangeEvent<string>) => {
		const { name, value } = e.target;
		setFormData((prev) => ({
			...prev,
			[name]: value,
		}));

		// Clear error when selecting
		if (errors.category) {
			setErrors((prev) => ({ ...prev, category: '' }));
		}
	};

	const handleSubmit = async (e: React.FormEvent) => {
		e.preventDefault();

		if (!validateForm()) {
			return;
		}

		const formDataToSend = new FormData();
		formDataToSend.append('subCategory', formData.subCategory);
		formDataToSend.append('description', formData.description);
		formDataToSend.append('category', formData.category);
		formDataToSend.append(
			'slug',
			formData.slug || formData.subCategory.toLowerCase().replace(/[^a-z0-9-]/g, '-')
		);

		if (formData.subCategoryImage) {
			formDataToSend.append('subCategoryImage', formData.subCategoryImage);
		}

		onsubmit(formDataToSend);
	};

	return (
		<form onSubmit={handleSubmit}>
			{/* <Typography variant="h6" gutterBottom>
                {subCategory ? 'Edit Sub-Category' : 'Create New Sub-Category'}
            </Typography> */}
			<Grid container spacing={2} mt={2}>
				<Grid item xs={12}>
					<FormControl fullWidth size="small" error={!!errors.category}>
						<InputLabel>Category *</InputLabel>
						<Select
							name="category"
							value={formData.category}
							label="Category *"
							onChange={handleCategoryChange}
							required
						>
							<MenuItem value="">Select Category</MenuItem>
							{categories.map((category) => (
								<MenuItem key={category._id} value={category.name}>
									{category.name}
								</MenuItem>
							))}
						</Select>
						{errors.category && (
							<Box sx={{ color: 'error.main', fontSize: '0.75rem', ml: 2, mt: 0.5 }}>
								{errors.category}
							</Box>
						)}
					</FormControl>
				</Grid>
				<Grid item xs={12}>
					<TextField
						label="Sub-Category Name"
						variant="outlined"
						name="subCategory"
						size="small"
						fullWidth
						value={formData.subCategory}
						onChange={handleSubCategoryChange}
						error={!!errors.subCategory}
						helperText={errors.subCategory}
						required
					/>
				</Grid>
				<Grid item xs={12}>
					<TextField
						label=" eg..Slug-new"
						variant="outlined"
						name="slug"
						size="small"
						fullWidth
						value={formData.slug}
						onChange={handleSlugChange}
						helperText={
							errors.slug ||
							'Only lowercase letters, numbers, and hyphens are allowed'
						}
						error={!!errors.slug}
						required
					/>
				</Grid>
				<Grid item xs={12}>
					<TextField
						label="Description"
						variant="outlined"
						size="small"
						name="description"
						fullWidth
						multiline
						rows={4}
						value={formData.description}
						onChange={(e) => {
							setFormData((prev) => ({ ...prev, description: e.target.value }));
							if (errors.description) {
								setErrors((prev) => ({ ...prev, description: '' }));
							}
						}}
						error={!!errors.description}
						helperText={errors.description}
						// required
					/>
				</Grid>

				<Grid item xs={12}>
					<Box>
						{(imagePreview || subCategory?.subCategoryImage) && (
							<Box sx={{ mt: 2, position: 'relative', display: 'inline-block' }}>
								<img
									src={imagePreview || `${subCategory.subCategoryImage[0]}`}
									alt="Preview"
									style={{
										maxWidth: '100%',
										maxHeight: 100,
										position: 'relative',
									}}
								/>
								<IconButton
									onClick={handleDeleteImage}
									sx={{
										position: 'absolute',
										top: 0,
										right: 0,
										backgroundColor: 'rgba(255, 255, 255, 0.7)',
										'&:hover': {
											backgroundColor: 'rgba(255, 255, 255, 0.9)',
										},
									}}
								>
									<CloseIcon color="error" />
								</IconButton>
							</Box>
						)}
					</Box>
					<Button variant="contained" component="label">
						Upload Image
						<input
							type="file"
							hidden
							name="subCategoryImage"
							accept="image/*"
							onChange={handleFileChange}
						/>
					</Button>

					{errors.subCategoryImage && (
						<Box sx={{ color: 'error.main', fontSize: '0.75rem', ml: 2, mt: 0.5 }}>
							{errors.subCategoryImage}
						</Box>
					)}
				</Grid>

				<Grid item xs={12} sx={{ display: 'flex', gap: 2, justifyContent: 'end' }}>
					<Button type="submit" variant="contained" color="primary">
						{subCategory ? 'Update Sub-Category' : 'Create Sub-Category'}
					</Button>
					<Button
						variant="outlined"
						onClick={onClose}
						sx={{ ':hover': { backgroundColor: '#f0f0f0' } }}
					>
						Cancel
					</Button>
				</Grid>
			</Grid>
		</form>
	);
};

export default CreateSubCategory;
